const mutations = {
  SET_ERROR_MESSAGE(state, object) {
    state.errorMessage.required = object.required;
    state.errorMessage.endpoints.push(object.endpoint);
    state.errorMessage.messages.push(object.message);
  },
  REMOVE_ERROR_MESSAGE(state) {
    state.errorMessage = {
      required: false,
      endpoints: [],
      messages: []
    };
  }
};

export default mutations;
